import React from "react";
import { Box, Typography } from "@mui/material";
import { partName, policyNumberRows } from "../utils/policyParts";

/**
 * The hover card of the list's Policy / Proposal column.
 *
 * Every number appears ONCE (policyNumberRows): the policy's own, then — only
 * when they add something — the parts', then our own OP… reference. It used to
 * print the policy number and the proposal number a second time as the bundled
 * part's "OD + TP (Reliance): Proposal No … · Policy No …".
 */
const PolicyNumbersTip = ({ row }) => {
  const numbers = policyNumberRows(row);
  return (
    <Box sx={{ py: 0.25 }}>
      {numbers.policy.map(([label, value]) => (
        <Typography key={label} sx={{ fontSize: 12 }}>
          {label}: <strong>{value}</strong>
        </Typography>
      ))}
      {/* Each part is bought on its own, so it has its own numbers. */}
      {numbers.parts.map(({ part, lines }) => (
        <Typography key={part.key} sx={{ fontSize: 12 }}>
          {partName(part)}:{" "}
          <strong>{lines.map(([label, value]) => `${label} ${value}`).join(" · ")}</strong>
        </Typography>
      ))}
      {row.policyId && (
        <Typography sx={{ fontSize: 12 }}>
          Reference: <strong>{row.policyId}</strong>
        </Typography>
      )}
      {!row.policyNumber && !row.proposalNumber && numbers.parts.length === 0 && (
        <Typography sx={{ fontSize: 11, color: "#EAECF0" }}>Not yet submitted to the insurer</Typography>
      )}
    </Box>
  );
};

export default PolicyNumbersTip;
